import UploadDocumentModal from "./UploadDocumentModal";

export default UploadDocumentModal;
